import styled from "styled-components";

// function mixColorWithWhite(hex, percentage) {
//   const whitePercentage = (100 - percentage) / 100;

//   let r = parseInt(hex.slice(1, 3), 16);
//   let g = parseInt(hex.slice(3, 5), 16);
//   let b = parseInt(hex.slice(5, 7), 16);

//   r = Math.floor(r + (255 - r) * whitePercentage);
//   g = Math.floor(g + (255 - g) * whitePercentage);
//   b = Math.floor(b + (255 - b) * whitePercentage);

//   return `#${r.toString(16).padStart(2, "0")}${g
//     .toString(16)
//     .padStart(2, "0")}${b.toString(16).padStart(2, "0")}`;
// }

const Corners = styled.a`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ speciality, isActive, isPreviousActive, isLast }) => `
    
    &::before,
    &::after {
      content: "";
      position: absolute;
      top: 0;
      width: 0;
      height: 0;
      z-index: 3;
    }

    &::before {
      right: 100%;
      border-left: 5px solid transparent;
      border-top: 25px solid ${speciality.color};
      ${isActive ? `border-top: 0; border-bottom: 25px solid ${speciality.color};` : ""}
    }

    &::after {
      left: 100%;
      border-right: 5px solid transparent;
      ${
        isPreviousActive
          ? `border-top: 25px solid ${isActive ? speciality.color : speciality.color};
             border-bottom: 0;`
          : `border-bottom: 25px solid ${isActive ? speciality.color : speciality.color};
             border-top: 0;`
      }
      ${isPreviousActive ? "z-index: 4;" : ""}
      // ${isLast ? "display: none;" : ""}
    }
  `}
`;

function CasePageSpeciality({
  specialitie,
  onSpecialtyChange,
  isActive,
  isPreviousActive,
  isLast,
  specialityWidth,
  isFirst,
}) {
  const bgColor = isActive ? specialitie?.color : specialitie.color;

  return (
    <span className={`has-speciality-color-${specialitie?.id}`} style={{ display: "contents" }}>
      <Corners
        speciality={specialitie}
        isActive={isActive}
        isPreviousActive={isPreviousActive}
        isLast={isLast}
        onClick={() => onSpecialtyChange(specialitie?.id)}
        style={{
          cursor: "pointer",
          backgroundColor: bgColor,
          height: "25px",
          // flex: "1 1 0", // full width stretch
          color: "white",
          width: `${specialityWidth}px`,
          maxWidth: "max-content",
          minWidth: "25px",
          fontWeight: "700",
          fontSize: "16px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: isActive ? 5 : 3,
          marginRight: isLast ? "0px" : "5px", // ✅ remove gap (edge-to-edge)
        }}
      >
        {/* ✅ TEXT WRAPPER (important fix) */}
        <span
          className="tab-text "
          style={{
            padding: isFirst ? "0 6.5px 0px 6.5px" : "0 6.5px 0px 6.5px",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            textAlign: "center",
          }}
        >
          {specialitie?.name[0]}
        </span>
      </Corners>
    </span>
  );
}

export default CasePageSpeciality;
